/**
 * Theme custom scripts (non-module). Swiper 11 is loaded from jsDelivr in theme.liquid before this file.
 */

(function () {
  var MQ_WIDE = '(min-width: 700px)';

  function destroyCarousel(el) {
    if (el && el.swiper && typeof el.swiper.destroy === 'function') {
      el.swiper.destroy(true, true);
    }

    delete el.dataset.productsSwiperInitialized;
  }

  function destroyImageCarousel(el) {
    if (el && el.swiper && typeof el.swiper.destroy === 'function') {
      el.swiper.destroy(true, true);
    }

    delete el.dataset.imageCarouselSwiperInitialized;
  }

  function shouldShowProductSwiper(root) {
    if (!root || !root.dataset) {
      return true;
    }

    var wide = window.matchMedia(MQ_WIDE).matches;
    var desk = root.dataset.desktopLayout;
    var mob = root.dataset.mobileLayout;

    if (wide) {
      return desk === 'carousel';
    }

    return mob === 'swipe';
  }

  function syncCarouselScrollable(swiper) {
    if (!swiper || !swiper.el) {
      return;
    }

    if (swiper.isLocked) {
      swiper.el.classList.remove('is-scrollable');
    } else {
      swiper.el.classList.add('is-scrollable');
    }
  }

  function renderProductSwiperDots(swiper, paginationEl) {
    if (!swiper || !paginationEl) {
      return;
    }

    var slideCount = swiper.slides ? swiper.slides.length : 0;

    if (slideCount <= 1 || swiper.isLocked) {
      paginationEl.innerHTML = '';
      paginationEl.setAttribute('hidden', '');
      return;
    }

    paginationEl.removeAttribute('hidden');

    if (paginationEl.children.length !== slideCount) {
      paginationEl.innerHTML = '';

      for (var i = 0; i < slideCount; i++) {
        var dot = document.createElement('button');

        dot.type = 'button';
        dot.className = 'swiper-pagination-bullet';
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.dataset.slideIndex = String(i);

        dot.addEventListener('click', function (event) {
          var index = parseInt(event.currentTarget.dataset.slideIndex, 10);

          if (!isNaN(index)) {
            swiper.slideTo(index);
          }
        });

        paginationEl.appendChild(dot);
      }
    }

    var activeIndex = swiper.activeIndex || 0;
    var dots = paginationEl.querySelectorAll('.swiper-pagination-bullet');

    for (var d = 0; d < dots.length; d++) {
      var isActive = d === activeIndex;

      dots[d].classList.toggle(
        'swiper-pagination-bullet-active',
        isActive
      );

      dots[d].setAttribute(
        'aria-current',
        isActive ? 'true' : 'false'
      );
    }
  }

  function initSingleProductSwiper(el) {
    if (!el || el.dataset.productsSwiperInitialized === 'true') {
      return;
    }

    var container =
      el.closest('[data-product-grid-swiper-wrap]') ||
      el.closest('.floating-controls-container');

    var prevEl =
      container &&
      container.querySelector('[data-products-swiper-prev]');

    var nextEl =
      container &&
      container.querySelector('[data-products-swiper-next]');

    var paginationEl =
      container &&
      container.querySelector('[data-products-swiper-pagination]');

    el.dataset.productsSwiperInitialized = 'true';

    /* global Swiper */
    var swiper = new Swiper(el, {
      slidesPerView: 2,
      spaceBetween: 16,
      watchOverflow: true,
      resistanceRatio: 0.85,
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      resizeObserver: true,

      breakpoints: {
        700: {
          slidesPerView: 4,
          spaceBetween: 15,
        },
      },

      navigation:
        prevEl && nextEl
          ? {
              prevEl: prevEl,
              nextEl: nextEl,
            }
          : undefined,

      on: {
        init: function (sw) {
          syncCarouselScrollable(sw);
          renderProductSwiperDots(sw, paginationEl);
        },

        lock: function (sw) {
          syncCarouselScrollable(sw);
          renderProductSwiperDots(sw, paginationEl);
        },

        unlock: function (sw) {
          syncCarouselScrollable(sw);
          renderProductSwiperDots(sw, paginationEl);
        },

        resize: function (sw) {
          syncCarouselScrollable(sw);
          renderProductSwiperDots(sw, paginationEl);
        },

        breakpoint: function (sw) {
          syncCarouselScrollable(sw);
          renderProductSwiperDots(sw, paginationEl);
        },

        update: function (sw) {
          syncCarouselScrollable(sw);
          renderProductSwiperDots(sw, paginationEl);
        },

        slideChange: function (sw) {
          renderProductSwiperDots(sw, paginationEl);
        },
      },
    });

    syncCarouselScrollable(swiper);
    renderProductSwiperDots(swiper, paginationEl);

    window.requestAnimationFrame(function () {
      swiper.update();
      syncCarouselScrollable(swiper);
      renderProductSwiperDots(swiper, paginationEl);

      window.requestAnimationFrame(function () {
        swiper.update();
        syncCarouselScrollable(swiper);
        renderProductSwiperDots(swiper, paginationEl);
      });
    });
  }

  function syncProductGridSwiper(root) {
    var swiperWrap = root.querySelector(
      '[data-product-grid-swiper-wrap]'
    );

    var swiperEl = root.querySelector('[data-products-swiper]');
    var listEl = root.querySelector('[data-product-grid-list]');

    if (!swiperEl || !listEl || !swiperWrap) {
      return;
    }

    var wantSwiper = shouldShowProductSwiper(root);

    if (wantSwiper) {
      listEl.setAttribute('hidden', '');
      swiperWrap.removeAttribute('hidden');

      if (swiperEl.dataset.productsSwiperInitialized !== 'true') {
        initSingleProductSwiper(swiperEl);
      } else if (swiperEl.swiper) {
        swiperEl.swiper.update();
        syncCarouselScrollable(swiperEl.swiper);
      }
    } else {
      destroyCarousel(swiperEl);
      swiperWrap.setAttribute('hidden', '');
      listEl.removeAttribute('hidden');
    }
  }

  function syncAllProductGridSwipers(scope) {
    var searchRoot =
      scope && scope.nodeType === 1 ? scope : document;

    var roots = searchRoot.querySelectorAll(
      '[data-product-grid-root]'
    );

    for (var r = 0; r < roots.length; r++) {
      syncProductGridSwiper(roots[r]);
    }
  }

  function initProductCarousels(root) {
    if (typeof Swiper === 'undefined') {
      return;
    }

    var scope =
      root && root.nodeType === 1 ? root : document;

    syncAllProductGridSwipers(scope);
  }

  function syncImageCarouselScrollable(sw) {
    if (!sw || !sw.el) {
      return;
    }

    if (sw.isLocked) {
      sw.el.classList.remove('is-scrollable');
    } else {
      sw.el.classList.add('is-scrollable');
    }
  }

  function initImageCarousels(root) {
    if (typeof Swiper === 'undefined') {
      return;
    }

    var scope =
      root && root.nodeType === 1 ? root : document;

    var nodes = scope.querySelectorAll(
      '[data-image-carousel-swiper]'
    );

    for (var k = 0; k < nodes.length; k++) {
      var elImg = nodes[k];

      if (
        elImg.dataset.imageCarouselSwiperInitialized === 'true'
      ) {
        continue;
      }

      elImg.dataset.imageCarouselSwiperInitialized = 'true';

      var fc = elImg.closest('.floating-controls-container');

      var prevImg =
        fc && fc.querySelector('[data-image-carousel-prev]');

      var nextImg =
        fc && fc.querySelector('[data-image-carousel-next]');

      /* global Swiper */
      var swiperImg = new Swiper(elImg, {
        slidesPerView: 1.4,
        spaceBetween: 12,
        watchOverflow: true,
        resistanceRatio: 0.85,
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        resizeObserver: true,

        breakpoints: {
          700: {
            slidesPerView: 2.3,
            spaceBetween: 20,
          },
        },

        navigation:
          prevImg && nextImg
            ? {
                prevEl: prevImg,
                nextEl: nextImg,
              }
            : undefined,

        on: {
          init: function (sw) {
            syncImageCarouselScrollable(sw);
          },

          lock: function (sw) {
            syncImageCarouselScrollable(sw);
          },

          unlock: function (sw) {
            syncImageCarouselScrollable(sw);
          },

          resize: function (sw) {
            syncImageCarouselScrollable(sw);
          },

          breakpoint: function (sw) {
            syncImageCarouselScrollable(sw);
          },

          update: function (sw) {
            syncImageCarouselScrollable(sw);
          },
        },
      });

      syncImageCarouselScrollable(swiperImg);

      window.requestAnimationFrame(function () {
        swiperImg.update();
        syncImageCarouselScrollable(swiperImg);

        window.requestAnimationFrame(function () {
          swiperImg.update();
          syncImageCarouselScrollable(swiperImg);
        });
      });
    }
  }

  var productGridMq = window.matchMedia(MQ_WIDE);

  function onProductGridBreakpoint() {
    syncAllProductGridSwipers(document);
  }

  if (productGridMq.addEventListener) {
    productGridMq.addEventListener(
      'change',
      onProductGridBreakpoint
    );
  } else {
    productGridMq.addListener(onProductGridBreakpoint);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initProductCarousels(document);
    initImageCarousels(document);
    initCollectionSidebarToggle();
  });

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      if (event.target) {
        initProductCarousels(event.target);
        initImageCarousels(event.target);
        syncAllProductGridSwipers(event.target);
      }
    }
  );

  document.addEventListener(
    'shopify:section:unload',
    function (event) {
      var target = event.target;

      if (!target || !target.querySelectorAll) {
        return;
      }

      var carousels = target.querySelectorAll(
        '[data-products-swiper]'
      );

      for (var j = 0; j < carousels.length; j++) {
        destroyCarousel(carousels[j]);
      }

      var imageCarousels = target.querySelectorAll(
        '[data-image-carousel-swiper]'
      );

      for (var ic = 0; ic < imageCarousels.length; ic++) {
        destroyImageCarousel(imageCarousels[ic]);
      }
    }
  );

  window.initProductCarouselSwipers = initProductCarousels;
  window.initImageCarouselSwipers = initImageCarousels;

  function initCollectionSidebarToggle() {
    if (
      document.documentElement.dataset
        .collectionSidebarToggleInit === 'true'
    ) {
      return;
    }

    document.documentElement.dataset.collectionSidebarToggleInit =
      'true';

    document.addEventListener('click', function (event) {
      var btn = event.target.closest(
        '[data-collection-sidebar-toggle]'
      );

      if (!btn) {
        return;
      }

      var section = btn.closest('.shopify-section');

      if (!section) {
        return;
      }

      var sidebar = section.querySelector(
        'safe-sticky.facets-sidebar, .facets-sidebar'
      );

      if (!sidebar) {
        return;
      }

      var isExpanded =
        btn.getAttribute('aria-expanded') === 'true';

      var nextExpanded = !isExpanded;

      sidebar.classList.toggle('expended', nextExpanded);

      section.classList.toggle(
        'collection-sidebar-collapsed',
        !nextExpanded
      );

      btn.setAttribute(
        'aria-expanded',
        nextExpanded ? 'true' : 'false'
      );
    });
  }

  document.addEventListener('click', event => {
    const tab = event.target.closest('.pi--tab');

    if (!tab) return;

    const tabsWrapper = tab.closest('.pi--tabs');

    if (!tabsWrapper) return;

    const target = tab.dataset.tab;

    tabsWrapper.querySelectorAll('.pi--tab').forEach(item => {
      item.classList.toggle('active', item === tab);
    });

    tabsWrapper
      .querySelectorAll('.pi--tab-output')
      .forEach(output => {
        output.classList.toggle(
          'active',
          output.dataset.tab === target
        );
      });
  });
})();